<template>
  <div class="footPage">
    <div data-v-0820c43d="" data-v-103b7291="" class="footer-warpper">
      Copyright 益魔方 <a target="_blank" href="http://beian.miit.gov.cn" class="margin-left-xs">京ICP备15038897号-3 </a>
      <img class="beian" src="http://www.beian.gov.cn/img/new/gongan.png">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802038214"
                         class="margin-right-xs">京公网安备11010802038214号</a>
      北京易魔方科技集团有限公司 版权所有
    </div>
  </div>
</template>
<script>
export default {
  name: "footPage",
  data() {
    return {}
  },
  components: {},
  created() {

  },
  methods: {},
  watch: {},
  filters: {}
}
</script>

<style scoped lang="scss">
.footPage {
  .footer-warpper {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    align-items: center;
    background-color: #0a2240;
    color: #fff;
    flex-shrink: 0;
    a {
      font-size: 14px;
      color: #fff;
      margin: 0 5px;
    }
    .beian {
      width: 15px;
      height: 15px;
      margin: 0 5px;
    }
  }
}
</style>


